import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { useTheme } from '../pages/Landing/theme-provider';

const CalendlyModal = ({ isOpen, onClose, calendlyUrl = "https://calendly.com/asiffarhankhan1/smushchat-demo" }) => {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";

  useEffect(() => {
    // Prevent scrolling when modal is open
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop with blur effect */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm" 
        onClick={onClose}
      ></div>
      
      {/* Modal content - no padding */}
      <div className={`relative w-full max-w-4xl h-[90vh] rounded-xl overflow-hidden shadow-2xl ${
        isDarkMode ? 'bg-gray-900' : 'bg-white'
      } z-10 flex flex-col`}>
        {/* Header - minimal height */}
        <div className={`flex justify-between items-center h-12 px-4 ${
          isDarkMode ? 'bg-gray-800 border-b border-gray-700' : 'bg-gray-50 border-b border-gray-200'
        }`}>
          <h3 className={`text-base font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            Schedule a Demo
          </h3>
          <button 
            onClick={onClose}
            className={`flex items-center justify-center w-8 h-8 rounded-full ${
              isDarkMode ? 'hover:bg-gray-700 text-gray-300' : 'hover:bg-gray-200 text-gray-500'
            }`}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>
        
        {/* Calendly iframe - full size with no padding */}
        <div className="flex-1 w-full h-full">
          <iframe
            src={calendlyUrl}
            width="100%"
            height="100%"
            frameBorder="0"
            title="Schedule a demo with Smush Chat"
            style={{ display: 'block' }} // Removes any inline spacing
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default CalendlyModal; 